import { SectionHeading, SectionLabel } from "./Section";

const agents = [
    { name: "Sales", tag: "Pipeline & closes" },
    { name: "Finance", tag: "Cash & burn" },
    { name: "HR", tag: "Hiring & people" },
    { name: "Operations", tag: "Delivery ops" },
    { name: "Marketing", tag: "ROI & funnel" },
    { name: "Customer", tag: "Churn & NPS" },
    { name: "Procurement", tag: "Vendors & costs" },
    { name: "Legal", tag: "Contracts & risk" },
    { name: "Strategy", tag: "Bets & horizons" },
    { name: "Meeting", tag: "Notes to actions" },
];

const icons = {
    Sales: (
        <path d="M3 17l6-6 4 4 8-8" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" fill="none" />
    ),
    Finance: (
        <>
            <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.6" fill="none" />
            <path d="M12 7v10M9 9h5.5a1.5 1.5 0 010 3H10a1.5 1.5 0 000 3h5" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" fill="none" />
        </>
    ),
    HR: (
        <>
            <circle cx="12" cy="8" r="3.5" stroke="currentColor" strokeWidth="1.6" fill="none" />
            <path d="M4 20c1.5-4 5-6 8-6s6.5 2 8 6" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" fill="none" />
        </>
    ),
    Operations: (
        <>
            <path d="M4 7l8-4 8 4-8 4-8-4z" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" fill="none" />
            <path d="M4 12l8 4 8-4M4 17l8 4 8-4" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" fill="none" />
        </>
    ),
    Marketing: (
        <path d="M3 12l14-8v16L3 12zM19 8v8" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" strokeLinecap="round" fill="none" />
    ),
    Customer: (
        <>
            <path d="M21 12c0 4.5-4 8-9 8-1.4 0-2.7-.2-3.9-.7L3 21l1.7-4.4C3.6 15.1 3 13.6 3 12c0-4.5 4-8 9-8s9 3.5 9 8z" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" fill="none" />
        </>
    ),
    Procurement: (
        <>
            <path d="M6 7h14l-1.5 10a2 2 0 01-2 1.7H9.5a2 2 0 01-2-1.7L6 7z" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" fill="none" />
            <path d="M9 7V5.5A2.5 2.5 0 0111.5 3h3A2.5 2.5 0 0117 5.5V7" stroke="currentColor" strokeWidth="1.6" fill="none" />
        </>
    ),
    Legal: (
        <>
            <path d="M12 3v18M4 8h16M6 8l-2 6a4 4 0 008 0l-2-6M14 8l-2 6a4 4 0 008 0l-2-6" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" fill="none" />
        </>
    ),
    Strategy: (
        <>
            <circle cx="6" cy="6" r="2.2" stroke="currentColor" strokeWidth="1.6" fill="none" />
            <circle cx="18" cy="18" r="2.2" stroke="currentColor" strokeWidth="1.6" fill="none" />
            <circle cx="18" cy="6" r="2.2" stroke="currentColor" strokeWidth="1.6" fill="none" />
            <path d="M6 8v8a2 2 0 002 2h8M8 6h8" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" fill="none" />
        </>
    ),
    Meeting: (
        <>
            <rect x="3" y="5" width="14" height="12" rx="2" stroke="currentColor" strokeWidth="1.6" fill="none" />
            <path d="M17 9l4-2v10l-4-2" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" fill="none" />
        </>
    ),
};

export default function Agents() {
    return (
        <section id="agents" data-testid="agents-section" className="relative py-28 sm:py-36">
            <div className="mx-auto max-w-7xl px-6 lg:px-8">
                <div className="grid lg:grid-cols-[1fr_1.4fr] gap-14 items-end">
                    <div className="reveal">
                        <SectionLabel num="04">10 AI Business Agents</SectionLabel>
                        <SectionHeading className="mt-6">
                            10 AI agents working{" "}
                            <span className="italic font-normal">
                                silently
                            </span>{" "}
                            behind your company.
                        </SectionHeading>
                    </div>
                    <p className="reveal text-[15px] sm:text-lg text-neutral-600 leading-relaxed max-w-xl lg:justify-self-end">
                        Employees enter data through role-based workspaces. CEO’s
                        GPT agents observe every department in the background
                        and convert updates into CEO-ready decisions.
                    </p>
                </div>

                <div className="mt-14 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3.5">
                    {agents.map((a, i) => (
                        <div
                            key={a.name}
                            data-testid={`agent-card-${a.name.toLowerCase()}`}
                            className="reveal group relative glass rounded-2xl p-5 hover:-translate-y-1 hover:shadow-[0_16px_50px_-20px_rgba(139,92,246,0.35)] hover:border-violet-200 transition-all duration-500"
                            style={{ transitionDelay: `${(i % 5) * 60}ms` }}
                        >
                            <div className="flex items-center justify-between">
                                <span className="inline-flex items-center justify-center h-10 w-10 rounded-xl bg-white border border-black/5 text-neutral-700 group-hover:text-violet-600 transition-colors">
                                    <svg width="20" height="20" viewBox="0 0 24 24">
                                        {icons[a.name]}
                                    </svg>
                                </span>
                                <span className="font-mono-alt text-[10px] text-neutral-400">
                                    /{String(i + 1).padStart(2, "0")}
                                </span>
                            </div>
                            <div className="mt-8 font-display text-[19px] font-medium text-black tracking-tight">
                                {a.name}
                            </div>
                            <div className="mt-1 text-[11.5px] text-neutral-500">
                                {a.tag}
                            </div>
                            <div className="mt-4 flex items-center gap-1.5 text-[10px] font-medium tracking-[0.16em] uppercase text-neutral-400">
                                <span className="h-1.5 w-1.5 rounded-full bg-emerald-500 anim-pulse-glow" />
                                Live
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
